import React from 'react';
import './NosTrophees.css';
import { useTranslation } from 'react-i18next';

const NosTrophees: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="nos-trophees">
      <div className="container">
        <h2 className="section-title gr-title-2">{t('nosTrophees.title')}</h2>
        <div className="trophees-container">
          <div className="trophee-card">
            <div className="trophee-image">
              <img 
                src="/images/total.png" 
                alt={t('nosTrophees.alt_total')} 
                className="trophy-img"
              />
            </div>
            <p className="trophee-text">
              {t('nosTrophees.total_award')}
            </p>
          </div>

          <div className="trophee-card">
            <div className="trophee-image">
              <img 
                src="/images/ibticar-price.png" 
                alt={t('nosTrophees.alt_ibtikar')} 
                className="trophy-img"
              />
            </div>
            <p className="trophee-text">
              {t('nosTrophees.ibtikar_award')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NosTrophees;
